<section id="testimonios" class="testimonials">
    <div class="container">
        <div class="section-header">
            <h2>Lo Que Dicen Nuestros Clientes</h2>
            <div class="divider"></div>
        </div>
        <div class="testimonials-slider">
            <div class="testimonial">
                <div class="testimonial-content">
                    <p>"La mejor comida china que he probado en la ciudad. El pato Pekín es simplemente espectacular y el servicio es impecable. Siempre que tenemos una celebración especial, Don Chon es nuestra primera opción."</p>
                </div>
                <div class="testimonial-author">
                    <!-- <img src="/placeholder.svg?height=60&width=60" alt="Cliente"> -->
                    <div class="author-info">
                        <h4>María Rodríguez</h4>
                        <div class="stars">★★★★★</div>
                    </div>
                </div>
            </div>
            <div class="testimonial">
                <div class="testimonial-content">
                    <p>"Increíble experiencia gastronómica. Los sabores son auténticos y el ambiente es muy acogedor. Los dim sum son los mejores que he probado fuera de China. Definitivamente volveré pronto."</p>
                </div>
                <div class="testimonial-author">
                    <!-- <img src="/placeholder.svg?height=60&width=60" alt="Cliente"> -->
                    <div class="author-info">
                        <h4>Carlos Méndez</h4>
                        <div class="stars">★★★★★</div>
                    </div>
                </div>
            </div>
            <div class="testimonial">
                <div class="testimonial-content">
                    <p>"Celebramos el cumpleaños de mi esposa en Don Chon y fue una velada perfecta. La comida deliciosa, el servicio atento y el ambiente elegante. El Hot Pot es una experiencia que hay que probar al menos una vez en la vida."</p>
                </div>
                <div class="testimonial-author">
                    <!-- <img src="/placeholder.svg?height=60&width=60" alt="Cliente"> -->
                    <div class="author-info">
                        <h4>Alejandro Torres</h4>
                        <div class="stars">★★★★★</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>